import FinderViewBase from '../FinderViewBase/FinderViewBase';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DynaReportHome.html?raw';
//import "../AddressFinder/AddressFinderTypes";

interface DynaCfgWebRoleResult {
    code: string;
    description: string;
}

interface DynaCfgResult {
    name: string;
    description: string;
    DataApi_FunctionName: string;
    OptionsApi_FunctionName: string;
    Layout_Json: string;
    Translation_BtnContinueLabel: string;
    Translation_BtnSubmitLabel: string;

    ref_web_role: DynaCfgWebRoleResult;
}

class DynaReportHome extends compose(FinderViewBase) {
    templateString: any = template;

    dynaCfg: "";
    tableParams: tableParams = { widgetName: "dynaTable", sContainerNodeName: "resultContainer" };

    // das alles bekommen wir dann von der API evtl oder whatever -- parameter die sich nicht ändern
    entityListAttributeName = "entitylist";
    //loadFilterDatatUrl = "dyna/finderdata?cfg=xy";
    loadFilterOptionsUrl = "dyna/reportoptions?cfg=xy";
    btnContinueLabelText = "TODO: btnContinueLabelText";
    btnSubmitLabelText = "TODO: btnSubmitLabelText";

    DynaReportCfgJSON: string = null;
    _cfg: DynaCfgResult = null;
    headerNode: HTMLHeadingElement;

    _layouts: any = [];

    _onClick_Submit(evt: Event) {
        if (this._isRequestActive === true || (this.isDirty != true && this._completeList.length >= this.lastResponse.totalResultCount)) {
            return;
        }
        this.getFilterlist();
    }

    // was wollen wir mit den FilterDaten anstellen
    processFilterListResponse_callback(): void {
        if (this.tableParams) {            
            this.createTable(this.tableParams.widgetName, this[this.tableParams.sContainerNodeName], /*Table Layout Name*/"default", this._completeList);
        } else {
            alert("table params?");
        }
    }

    postCreate(): void {

        if (this.DynaReportCfgJSON != null) {
            this._cfg = JSON.parse(this.DynaReportCfgJSON);

            this.loadFilterDatatUrl = "dyna/finderdata?cfg=" + this._cfg.name;
            this.loadFilterOptionsUrl = "dyna/reportoptions?cfg=" + this._cfg.name;
            //this._layouts = JSON.parse(this._cfg.Layout_Json);

            this.btnContinueLabelText = this.translations[this._cfg.Translation_BtnContinueLabel];
            this.btnSubmitLabelText = this.translations[this._cfg.Translation_BtnSubmitLabel];
            this.UiModder.domAttr.set(this.headerNode, "innerHTML", this._cfg.description); // mehrsprachiges Attribute wird über Locale der Session übersetzt
        }
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setDocumentTitle(this._cfg.description + " - " + this.translations["MainTitle"]);
        //this.setDocumentTitle("DynaFinder" + " - " + this.dynaCfg);
    }
}

export default mdsWidget(DynaReportHome);